const updates = [
  {
    time: '10分钟前',
    title: '某热门综艺节目录制现场突发意外，导演组紧急叫停',
    tag: '最新',
    tagStyle: 'bg-primary-500 text-background-50',
  },
  {
    time: '28分钟前',
    title: '知名演员深夜发文回应近期绯闻，网友讨论炸开锅',
    tag: '热门',
    tagStyle: 'bg-accent-500 text-background-50',
  },
  {
    time: '1小时前',
    title: '某头部网红直播间突然被封，粉丝群体集体炸毛',
    tag: '热门',
    tagStyle: 'bg-accent-500 text-background-50',
  },
  {
    time: '2小时前',
    title: '娱乐圈又爆大瓜！某女星被拍到与神秘男子同回公寓',
    tag: '爆款',
    tagStyle: 'bg-primary-500 text-background-50',
  },
  {
    time: '3小时前',
    title: '某品牌官方发布声明回应代言人争议，完整声明已整理',
    tag: '跟进',
    tagStyle: 'bg-secondary-500 text-background-50',
  },
  {
    time: '4小时前',
    title: '音乐节现场歌手与观众发生争执，完整视频已上传',
    tag: '新瓜',
    tagStyle: 'bg-secondary-500 text-background-50',
  },
  {
    time: '5小时前',
    title: '某选秀节目选手私下录音曝光，内容引发全网热议',
    tag: '热门',
    tagStyle: 'bg-accent-500 text-background-50',
  },
  {
    time: '6小时前',
    title: '影视剧拍摄现场路透视频流出，剧方紧急公关处理',
    tag: '跟进',
    tagStyle: 'bg-secondary-500 text-background-50',
  },
  {
    time: '7小时前',
    title: '业内人士爆料某对明星夫妻已分居数月，细节惊人',
    tag: '新瓜',
    tagStyle: 'bg-secondary-500 text-background-50',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时追踪最新吃瓜动态，新鲜热瓜第一时间送达
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>

          <div className="space-y-3">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className="flex items-start gap-4 pl-0 sm:pl-12 relative"
              >
                <div className="absolute left-[15px] top-2 w-[9px] h-[9px] rounded-full bg-primary-500 border-2 border-background-50 hidden sm:block"></div>
                <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-colors duration-200 cursor-pointer">
                  <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap">{item.time}</span>
                  <span className="flex-1 text-sm text-foreground-800 leading-relaxed">{item.title}</span>
                  <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap flex-shrink-0 ${item.tagStyle}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}